module.exports = [
  require('./fizban_s_platinum_shield_2021_04_14'),
  require('./flame_stride_2021_04_14'),
]
